/**
 * Activity checkout API (TRAV23 activities-front merge).
 *
 * The original hardcoded '/Activities/checkout' inline; it now goes through
 * `Urls.ActivityCheckoutBooking` like every other endpoint here.
 *
 * Note the two instances: booking goes through the BFF (`axiosInstance`) while the
 * question catalogues come from B2B (`axiosInstanceB2B`). That split is the backend's,
 * and is preserved as-is.
 */

import { AxiosPromise } from 'axios';

import { ICheckoutPayload } from '@share/common-types';
import { Urls } from '@share/constants';
import { axiosInstance, axiosInstanceB2B, getHeaders } from '@share/utils';

export const ActivityCheckoutAPI = {
  createBooking(payload: ICheckoutPayload): AxiosPromise<any> {
    return axiosInstance.post(Urls.ActivityCheckoutBooking, payload, {
      ...getHeaders(),
    });
  },

  getQuestions(): AxiosPromise<any> {
    return axiosInstanceB2B.get(Urls.ActivityQuestions, {
      ...getHeaders(),
    });
  },

  getConditionalQuestions(): AxiosPromise<any> {
    return axiosInstanceB2B.get(Urls.ActivityQuestionsConditional, {
      ...getHeaders(),
    });
  },
};
